var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiotx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_635_2457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8047 5.12012V10.3823L22.3735 7.75458L17.8047 5.12012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M22.375 7.75439V13.0166L26.9428 10.3821L22.375 7.75439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.8047 10.3823V15.6445L22.3735 13.0168L17.8047 10.3823ZM22.3735 13.0177V18.279L26.9415 15.6445L22.3735 13.0177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.8047 15.6445V20.9068L22.3735 18.2791L17.8047 15.6445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.375 18.2788V23.5411L26.9428 20.9067L22.375 18.2788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.99219 10.2046V15.4668L10.561 12.8323L5.99219 10.2046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.7578 12.1611V17.4233L16.319 14.7956L11.7578 12.1611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.375 15.4893V20.7514L12.9429 18.1169L8.375 15.4893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M11.3828 19.46V24.7222L15.9439 22.0876L11.3828 19.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M17.7656 21.7251V26.9883L22.3269 24.3528L17.7656 21.7251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M12.5156 9.5625V14.8257L17.0767 12.1979L12.5156 9.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M17.8033 5.12012V10.3823L13.2344 7.75458L17.8033 5.12012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M12.5151 7.35742V12.6186L7.94531 9.98417L12.5151 7.35742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.0844 9.96094V15.2241L12.5156 12.5887L17.0844 9.96094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M11.7407 12.1611V17.4233L7.17188 14.7956L11.7407 12.1611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.8033 15.6445V20.9068L13.2422 18.2791L17.8033 15.6445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M8.37355 16.8701V22.1325L3.80469 19.4968L8.37355 16.8701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9428 10.3823V15.6445L22.375 13.0168L26.9428 10.3823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M22.3735 13.0176V18.2789L17.8047 15.6443L22.3735 13.0176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M26.9428 15.6445V20.9068L22.375 18.2791L26.9428 15.6445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M22.3735 18.2788V23.5411L17.8047 20.9067L22.3735 18.2788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.7944 20.4717V25.7339L12.2266 23.1062L16.7944 20.4717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3735 7.75439V13.0166L17.8047 10.3821L22.3735 7.75439Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_635_2457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiotx);
export default __webpack_public_path__ + "static/media/tiotx.a4e61e2b2d5d789a1725a937d69735c3.svg";
export { ForwardRef as ReactComponent };